export class cxDate {
  constructor(difference) {
    this.styleId = 1
    this.textType = "title"
    this.width = 204
    this.height = 40
    this.top = 10
    this.left = 10
    this.innerElement = "cxDate"
    this.content = "日期"
    this.fontFamily = "sans-serif"
    this.lineHeight = 40
    this.fontSize = 20
    this.fontWeight = 400
    this.bgColor = "rgba(255,255,255,0)"
    this.color = "rgba(255,255,255,1)"
    this.colorType = "纯色"
    this.startColor = "rgba(0, 0, 0, 0.8)"
    this.endColor = "rgba(0, 0, 0, 0.8)"
    this.colorlinearGradientAngle = 90
    this.textIsThemeColor = false
    this.bgType = "自定义"
    this.fontStyle = "normal"
    this.letterSpacing = 0
    this.fontStyle = "normal"
    this.textAlign = "left"
    this.writingMode = "horizontal-tb"
    this.rotate = 0
    this.textDecoration = "none"
    this.textIndent = 0
    this.rotate = 0
    this.dateStyle = "1"
    this.weekStyle = "2"
    this.noCacheComponent = false // false: 静态数据；true: 数据源
    this.updateTimer = null // 数据源轮询时间
    this.restDataUrl = "" // 外接数据源地址
    this.usePageQuery = false //页面传参
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
export class HomeDate {
  constructor(difference) {
    this.textType = "title"
    this.width = 200
    this.height = 40
    this.top = 10
    this.left = 10
    this.innerElement = "cxDate"
    this.content = "日期"
    this.fontFamily = "sans-serif"
    this.lineHeight = 40
    this.fontSize = 20
    this.fontWeight = 400
    this.bgColor = "rgba(255,255,255,0)"
    this.color = "rgba(51, 51, 51, 1)"
    this.colorType = "纯色"
    this.startColor = "rgba(0, 0, 0, 0.8)"
    this.endColor = "rgba(0, 0, 0, 0.8)"
    this.colorlinearGradientAngle = 90
    this.textIsThemeColor = false
    this.bgType = "自定义"
    this.fontStyle = "normal"
    this.letterSpacing = 0
    this.fontStyle = "normal"
    this.textAlign = "left"
    this.writingMode = "horizontal-tb"
    this.rotate = 0
    this.textDecoration = "none"
    this.textIndent = 0
    this.rotate = 0
    this.dateStyle = "1"
    this.weekStyle = "2"
    this.animateSets = {
      animateType: 0,
      animateDirection: "无",
      animateDuration: 1.5,
      animateDelay: 0,
      hasDirection: false,
      animateTriggerNumType: "单次触发",
      animateClass: "",
      executionAnimateClass: ""
    }
    this.noCacheComponent = false // false: 静态数据；true: 数据源
    this.updateTimer = null // 数据源轮询时间
    this.restDataUrl = "" // 外接数据源地址
    this.usePageQuery = false //页面传参
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
